import React from 'react';
import PropTypes from 'prop-types';
import Yup from 'yup';
import { connect } from 'react-redux';
import { Field, Form, Formik } from 'formik';
import { getActiveSpace } from 'spaces/store/selectors';
import FormikDropzoneField from 'base/components/forms/formik/FormikDropzoneField';
import theme from 'theme/theme';
import MainTitle from 'base/components/MainTitle';
import Title3 from 'base/components/Title3';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import SubmitButton from 'base/components/forms/SubmitButton';
import ProgressBar from 'base/components/ProgressBar';
import ModalHeader from 'modal/components/ModalHeader';
import { uploadDocuments } from '../../store/documents/actions';
import { getActiveFolder, getActivePathStringWithSpace } from '../../store/folders/selectors';
import { getUploadPercent } from '../../store/documents/selectors';

const UploadDocumentModal = ({
  name, //eslint-disable-line
  space,
  folder,
  activePathString,
  uploadDocuments,
  uploadPercent,
}) => (
  <>
    <ModalHeader>
      <MainTitle>Upload</MainTitle>
    </ModalHeader>

    <FieldWrapper>
      Files will be uploaded to
      <Title3>{activePathString}</Title3>
    </FieldWrapper>

    <Formik
      initialValues={{
        files: [],
      }}
      validationSchema={
            Yup.object().shape({
              files: Yup.array()
                .required('Add at least one file'),
            })
          }
      render={({values, errors, isSubmitting, setFieldValue }) => ( // eslint-disable-line
        <Form>
          <div hidden={isSubmitting}>
            <Field
              type="text"
              name="files"
              placeholder="Name"
              component={FormikDropzoneField}
            />
            <SubmitButton type="submit" disabled={false}>
                Upload
            </SubmitButton>
          </div>
          <div hidden={!isSubmitting}>
              Uploading:
            <ProgressBar color={theme.colors.primary} percentage={uploadPercent} />
          </div>
        </Form>
      )}
      onSubmit={(values) => {
        uploadDocuments(values.files, space, folder);
      }}
    />
  </>
);
UploadDocumentModal.propTypes = {
  name: PropTypes.string.isRequired,
  space: PropTypes.objectOf(PropTypes.any),
  folder: PropTypes.objectOf(PropTypes.any),
  activePathString: PropTypes.string.isRequired,
  uploadDocuments: PropTypes.func.isRequired,
  uploadPercent: PropTypes.number.isRequired, // eslint-disable-line
};

UploadDocumentModal.defaultProps = {
  folder: null,
  space: null,
};

const mapStateToProps = (state) => ({
  space: getActiveSpace(state),
  folder: getActiveFolder(state),
  activePathString: getActivePathStringWithSpace(state),
  uploadPercent: getUploadPercent(state),
});

const mapDispatchToProps = {
  uploadDocuments,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UploadDocumentModal);
